import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faChartLine } from '@fortawesome/pro-regular-svg-icons/faChartLine';
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import type { PlatformsWidgetModel } from 'src/models/PlatformsWidgetModel';
import { PlatformsWidgetModelImpl } from 'src/models/PlatformsWidgetModel/impl';
import type { PlatformsWidgetState } from 'src/models/PlatformsWidgetModel/PlatformsSelfOwnedModel';
import type { SymbolsWidgetModel } from 'src/models/SymbolsWidgetModel';
import { SymbolsWidgetModelImpl } from 'src/models/SymbolsWidgetModel/impl';
import type { SymbolsWidgetState } from 'src/models/SymbolsWidgetModel/SymbolsSelfOwnedModel';
import type { TradersWidgetModel } from 'src/models/TradersWidgetModel';
import { TradersWidgetModelImpl } from 'src/models/TradersWidgetModel/impl';
import type { TradersWidgetState } from 'src/models/TradersWidgetModel/TradersSelfOwnedModel';

const defaultDimensions = { h: 0.4, w: 0.4, x: 0.3, y: 0.3 };

export const tradersWidgetDefinition: SelfOwnedWidgetDefinition<TradersWidgetState, TradersWidgetModel> = {
    type: 'traders' as const,
    nameKey: 'widgets::traders::name' as const,
    roles: ['widgets::traders'],
    icon: faUsers,
    category: 'widgets::categories::risk' as const,
    defaultDimensions,
    isLocalOnly: false,
    widgetClass: TradersWidgetModelImpl,
};

export const platformsWidgetDefinition: SelfOwnedWidgetDefinition<PlatformsWidgetState, PlatformsWidgetModel> = {
    type: 'platforms' as const,
    nameKey: 'widgets::platforms::name' as const,
    roles: ['widgets::platforms'],
    icon: faLayerGroup,
    category: 'widgets::categories::risk' as const,
    defaultDimensions,
    isLocalOnly: false,
    widgetClass: PlatformsWidgetModelImpl,
};

export const symbolsWidgetDefinition: SelfOwnedWidgetDefinition<SymbolsWidgetState, SymbolsWidgetModel> = {
    type: 'symbols' as const,
    nameKey: 'widgets::symbols::name' as const,
    roles: ['widgets::symbols'],
    icon: faChartLine,
    category: 'widgets::categories::risk' as const,
    defaultDimensions,
    isLocalOnly: false,
    widgetClass: SymbolsWidgetModelImpl,
};
